import { Component, OnInit, Input, Output, ElementRef, EventEmitter } from '@angular/core';
import { HighchartsChartComponent } from 'highcharts-angular';
import * as Highcharts from 'highcharts/highstock';
import { MonitorsSlaMonitorService } from 'e5core-angular-services';
import { MonitorsSLAMonitorData, MonitorsSlaMonitorModel, MonitorsSLAMonitorCategory } from 'e5core-angular-services';
import { MonitorSlaSelectEvent } from '../../../events/monitor-sla-select-event';
import { MonitorSlaChangeEvent } from '../../../events/monitor-sla-change-event';

@Component({
	selector: 'e5core-ui-monitor-sla-highcharts',
	templateUrl: './e5core-ui-monitor-sla-highcharts.component.html',
	styleUrls: ['./e5core-ui-monitor-sla-highcharts.component.css']
})
export class E5coreUiMonitorSlaHighchartsComponent implements OnInit {
	constructor(private monitorService: MonitorsSlaMonitorService) { 
		this.changeFlag = false; 
	}

	@Input() categorisation: number[]
	@Input() statuses: number[]
	@Input() slaRange: number = 24
	@Input() slaInDays: boolean = false
	@Output() categoryChange = new EventEmitter<MonitorSlaChangeEvent>() ;
	@Output() slaSelect = new EventEmitter<MonitorSlaSelectEvent>() ;

	model: MonitorsSlaMonitorModel
	public changeFlag: boolean
	public approachingSLARange: number
	public approachingSLAInDays: boolean
	public workStatuses: string


	ngOnInit() {
		let cat1Id = (this.categorisation && this.categorisation.length >= 1) ? this.categorisation[0] : 0;
		let cat2Id = (this.categorisation && this.categorisation.length >= 2) ? this.categorisation[1] : 0;
		let cat3Id = (this.categorisation && this.categorisation.length >= 3) ? this.categorisation[2] : 0;
		let categoryActivityId = (this.categorisation && this.categorisation.length >= 4) ? this.categorisation[3] : 0;
		this.approachingSLARange = (this.slaRange == 0) ? 24 : this.slaRange;
		this.approachingSLAInDays = this.slaInDays;
		this.workStatuses = (!this.statuses || this.statuses.length == 0) ? "1,2,3" : this.statuses.join(',');
		this.LoadChartObject(cat1Id, cat2Id, cat3Id, categoryActivityId, this.approachingSLARange, this.approachingSLAInDays, this.workStatuses);
	}

	public LoadChartObject(category1Id: number, category2Id: number, category3Id: number, categoryActivityId: number, slaRange: number, slaInHours: boolean, workStatus: string) {
		this.monitorService.getSlaMonitorWorkCounts(category1Id, category2Id, category3Id, categoryActivityId, { approachingSLARange: slaRange, isApproachingSLAInHours: slaInHours, statuses: workStatus }).subscribe(
			model => {
				this.chartOptions = {
					...this.chartOptions,
					xAxis: this.extractXAxis(model),// xAxis : { categories: ['Ancillary2', 'NSW Ambulance2'],title:{ rotation : -45}},
					series: this.extractSeries(model)// series: [{name:'InSLA',color:'#00cc99',data:[4,1]},{name:'Approaching', color:'#feb236', data:[8,3]},{name:'Expired', color:'#cc3300', data:[10,3]}]
				}

				this.model = model
			}
		)
	}

	private extractXAxis(model: MonitorsSlaMonitorModel): any {
		var output = {
			categories: model.data.map(i => i.slaCategoryName),
			title: { rotation: -45 },
			labels: {
				format: "<b class='xAxisLabel'>{value}</b>"
			}
		}
		return (output);
	}

	private extractSeries(model: MonitorsSlaMonitorModel): any {
		var series = [];
		var inSlaWorkCount = [];
		var approachingSlaWorkCount = [];
		var expiredWorkCount = [];
		for (let i = 0; i < model.data.length; i++) {
			inSlaWorkCount.push(model.data[i].inSlaWorkCount);
			approachingSlaWorkCount.push(model.data[i].approachingSlaWorkCount);
			expiredWorkCount.push(model.data[i].expiredWorkCount);
		}

		series.push({ name: 'InSLA', color: '#00cc99', data: inSlaWorkCount, drilldown: true });
		series.push({ name: 'Approaching', color: '#feb236', data: approachingSlaWorkCount, drilldown: true });
		series.push({ name: 'Expired', color: '#cc3300', data: expiredWorkCount, drilldown: true });
		return (series);
	}

	public GetSelectedCategorisation(categoryName: string): number[] {
		let selectedCategorisation: number[] = [];
		let clickedCategory: MonitorsSLAMonitorData[];
		let navigatorCount: number = 1;
		let category1Id = 0;
		let category2Id = 0;
		let category3Id = 0;
		let activityId = 0;

		navigatorCount = this.model.selectedCategories.length;
		clickedCategory = this.model.data.filter(item => item.slaCategoryName === categoryName);
		switch (navigatorCount) {
			case 1: {
				if (clickedCategory.length == 1) {
					category1Id = clickedCategory[0].slaCategoryId;
				}

				category2Id = 0;
				category3Id = 0;
				activityId = 0;
				break;
			}

			case 2: {
				if (clickedCategory.length == 1) {
					category2Id = clickedCategory[0].slaCategoryId;
				}

				category1Id = this.model.selectedCategories[1].categoryId;
				category3Id = 0;
				activityId = 0;
				break;
			}

			case 3: {
				if (clickedCategory.length == 1) {
					category3Id = clickedCategory[0].slaCategoryId;
				}

				category1Id = this.model.selectedCategories[1].categoryId;
				category2Id = this.model.selectedCategories[2].categoryId;
				activityId = 0;
				break;
			}

			case 4: {
				if (clickedCategory.length == 1) {
					activityId = clickedCategory[0].slaCategoryId;
				}

				category1Id = this.model.selectedCategories[1].categoryId;
				category2Id = this.model.selectedCategories[2].categoryId;
				category3Id = this.model.selectedCategories[3].categoryId;;
				break;
			}

			default: {
				category1Id = 0;
				category2Id = 0;
				category3Id = 0;
				activityId = 0;
			}
		}
		selectedCategorisation.push(category1Id);
		selectedCategorisation.push(category2Id);
		selectedCategorisation.push(category3Id);
		selectedCategorisation.push(activityId) ;
		return selectedCategorisation;
	}

	public ConstructCategorisation(categoryName: string): number[] {
		let selectedCategorisation: number[] = [];
		let category1Id = 0;
		let category2Id = 0;
		let category3Id = 0;
		let activityId = 0;
		let clickedCategoryIndex = 0;

		let categoryNames = this.model.selectedCategories.map(item => item.categoryName);
		clickedCategoryIndex = categoryNames.indexOf(categoryName);

		switch (clickedCategoryIndex) {
			case 1: {
				category1Id = this.model.selectedCategories[1].categoryId;
				category2Id = 0;
				category3Id = 0;
				activityId = 0 ;
				break;
			}

			case 2: {
				category1Id = this.model.selectedCategories[1].categoryId;
				category2Id = this.model.selectedCategories[2].categoryId;
				category3Id = 0;
				activityId = 0 ;
				break;
			}

			case 3: {
				category1Id = this.model.selectedCategories[1].categoryId;
				category2Id = this.model.selectedCategories[2].categoryId;
				category3Id = this.model.selectedCategories[3].categoryId;
				activityId = 0 ;
				break;
			}

			case 4: {
				category1Id = this.model.selectedCategories[1].categoryId;
				category2Id = this.model.selectedCategories[2].categoryId;
				category3Id = this.model.selectedCategories[3].categoryId;
				activityId = this.model.selectedCategories[4].categoryId;
				break;
			}

			case 0: {
				category1Id = 0;
				category2Id = 0;
				category3Id = 0;
				activityId = 0 ;
				break;
			}
			default: {
				category1Id = 0;
				category2Id = 0;
				category3Id = 0;
				activityId = 0 ;
			}
		}
		selectedCategorisation.push(category1Id);
		selectedCategorisation.push(category2Id);
		selectedCategorisation.push(category3Id);
		selectedCategorisation.push(activityId) ;
		return selectedCategorisation;
	}

	private drillDown(event) {
		alert(event);
	}

	clickMessage = '';
	Highcharts = Highcharts; // required
	chartConstructor = 'chart'; // optional string, defaults to 'chart'
	chartOptions = this.createChartOptions();
	createChartOptions() {
		let _this: E5coreUiMonitorSlaHighchartsComponent = this;

		return {
			chart: {
				type: 'column',
				events: {
				}
			},
			title: {
				text: 'Work SLA Monitor',
				style: {
					"fontSize": "16px",
					"font-weight": "bold"
				}
			},
			xAxis: {
				categories: [],
				title: { rotation: -45 }
			},
			yAxis: {
				min: 0,
				title: {
					text: 'Work Item Count',
				},
				labels: { x: -15 },
				stackLabels: {
					enabled: false,
					style: {
						fontWeight: 'bold',
						color: 'gray'
					}
				}
			},
			legend: {
				align: 'right',
				x: -30,
				verticalAlign: 'top',
				y: 25,
				floating: true,
				backgroundColor: 'white',
				borderColor: '#CCC',
				borderWidth: 1,
				shadow: false,
				itemStyle: {
					fontSize: '12px',
					font: '12pt',
				}
			},
			tooltip: {
				headerFormat: '<b>{point.x}</b><br/>',
				pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
			},
			plotOptions: {
				series: {					
					stacking: 'normal',
					dataLabels: {
						enabled: true,
						align: 'center',
						color: '#FFFFFF'
					},
					animation: {
						duration: 2000
					},
					cursor: 'pointer',
					point: {
						events: {
							click: function (event:MouseEvent) {
								_this.onClickBar(this, event) ;
								// let categorisation = _this.GetSelectedCategorisation(this.category);
								// if (categorisation.length == 3) {
								// 	_this.LoadChartObject(categorisation[0], categorisation[1], categorisation[2], 0, _this.approachingSLARange, _this.approachingSLAInDays, _this.workStatuses);
								// }
								// else {
								// 	_this.LoadChartObject(0, 0, 0, 0, 24, true, "1,2,3");
								// }
							}
						}
					}
				}
			},
			series: [{ name: 'InSLA', color: '#00cc99', data: [] }, { name: 'Approaching', color: '#feb236', data: [] }, { name: 'Expired', color: '#C62828', data: [] }],
			drilldown: {
				series: []
			}
		}; // required
	}
	chartCallback = null;// optional function, defaults to null
	updateFlag = false; // optional boolean
	oneToOneFlag = true; // optional boolean, defaults to false
	runOutsideAngularFlag = false;

	//------Documentation on SlaChartCallback : assign the *chartCallback like so, chartCallback = SlaChartCallback()--------------
	// public slaChartCallback(changeFlag,category,monitorService)
	// {
	//   if(changeFlag==true)
	//   {
	//     alert("Click Event : slachartCallback invoked!");
	//     changeFlag = false;
	//   }
	//   else
	//   { 
	//     alert("slachartCallback invoked!"); 
	//   }
	// }


	onNavigationCategoryClick(categoryName) {
		let categorisation = this.ConstructCategorisation(categoryName);
		if (categorisation.length == 4) {
			this.LoadChartObject(categorisation[0], categorisation[1], categorisation[2], 0, this.approachingSLARange, this.approachingSLAInDays, this.workStatuses);
		}
		else {
			this.LoadChartObject(0, 0, 0, 0, 24, true, '1,2,3');
		}
	}

	onClickBar(eventThis:any, eventData:MouseEvent) {
		let series = eventThis.series ? eventThis.series.name : "" ; 
		let category = eventThis.category || "" ;
		if(series && category) {
			console.log(`Select ${category}/${series}`) ;
			let cat = this.GetSelectedCategorisation(category);
			//let cat = this.GetSelectedCategorisation(category);
			if(cat.length == 4) {
				// console.log(`Bar ${cat[0]}/${cat[1]}/${cat[2]}/${cat[3]}/${series}`) ;
				this.slaSelect.emit({
					event: eventThis,
					category1Id : cat[0],
					category2Id : cat[1],
					category3Id : cat[2],
					activityId : cat[3],
					slaGroup : series
				}) ;	
				eventData.stopPropagation() ;
			}
		}
	}

	onClickAnywhere($event:any) {
		if($event.srcElement) {
			// Determine if we clicked on a xaxis label
			// this is a HACK!!!!
			let element = $event.srcElement ;
			let svg:SVGAnimatedString = element.className ;
			let className = svg ? svg.baseVal : undefined ;
			if(className && className.indexOf("xAxisLabel") >= 0) {
				let label:string = element.textContent ;
				let cat = this.GetSelectedCategorisation(label);
				if(cat && cat.length == 4) {
					// console.log(`Label ${cat[0]}/${cat[1]}/${cat[2]}/${cat[3]}/${label}`) ;
					this.categoryChange.emit({
						event: $event,
						category1Id : cat[0],
						category2Id : cat[1],
						category3Id : cat[2],
						activityId : cat[3]
					}) ;
					if(cat[3] == 0)
						this.LoadChartObject(
							cat[0], 
							cat[1], 
							cat[2], 
							cat[3], 
							this.approachingSLARange, 
							this.approachingSLAInDays, 
							this.workStatuses);
				}
				$event.stopPropagation() ;
			}
		}
	}

}



